<template>
  <div>
    <div v-if="!isAuthenticationGranted">
      <!-- nic nezobrazit -->
    </div>
    <div v-if="isAuthenticationGranted">
      <gov-button v-if="!isBusy" wcag-label="Košík" variant="primary" type="solid" size="m" hoverable id="gov-button-cart" class="gov-button-cart" @gov-click="cartClickHandler">
        <span class="material-icons-outlined" style="font-size: 16px; padding-top: 2px">shopping_cart</span>
        {{ this.$utils.localCurr(this.$store.state.cartSum) }}
      </gov-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartControl",
  data() {
    return {
      isAuthenticationGranted: null,
      isBusy: false,
    };
  },
  mounted() {
    this.isBusy = true;
    this.$backend.getAuthenticationStatus(reponse => {
      this.isAuthenticationGranted = reponse.data.authenticationGranted;
      this.isBusy = false;
    });
  },
  methods: {
    cartClickHandler() {
        this.$store.dispatch( "selectCart" );
        if (this.$router.currentRoute.name != "cart")
          this.$router.push( {name: "cart"} );
    },
  },
};
</script>
